import { InputAdornment } from '@mui/material';
import IncTextInputBase, {
  IncTextFieldBaseProps,
} from '../../inc-text-field/inc-text-input-base/inc-text-input-base.component';
import ReactCurrencyInput from '../react-currency-input/react-currency-input.component';
import { CurrencyInputProps } from 'react-currency-input-field';
import { Ref, forwardRef } from 'react';
import { getCurrencyInputSxStyles } from './currency-input-base.utils';

export type CurrencyInputBaseProps = IncTextFieldBaseProps & {
  currencySymbol?: string | null;
  inputProps?: CurrencyInputProps;
};

const CurrencyInputBase = forwardRef(
  (
    { currencySymbol = '$', inputProps, ...rest }: CurrencyInputBaseProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <IncTextInputBase
        inputProps={{
          step: 0.01,
          allowDecimals: true,
          disableGroupSeparators: false,
          allowNegativeValue: false,
          ...inputProps,
        }}
        InputProps={{
          startAdornment: !!currencySymbol && (
            <InputAdornment position="start">{currencySymbol}</InputAdornment>
          ),
          inputComponent: ReactCurrencyInput,
        }}
        ref={ref}
        sx={getCurrencyInputSxStyles(currencySymbol)}
        {...rest}
      />
    );
  },
);

export default CurrencyInputBase;
